import _ from "lodash";

import CONSTANTS from "./../common/constants";
import QueryHelper from "../common/queryHelper";
import { userManager } from "../components/OidcContext";

class Fetch {
	static async get(url, params, headers = {}, withCredentials = true, requiresAuthentication = true) {
		const token = await Fetch.getBearerToken();

		url = `${url}${QueryHelper.GetParameterString(params)}`;

		return fetch(url, {
			credentials: withCredentials ? `include` : `omit`,
			headers: {
				...(requiresAuthentication && token && { Authorization: `Bearer ${token}`}),
				...headers
			}
		}).then(Fetch.catchErr);
	}

	static async post(url, body, headers = {}, requiresAuthentication = true) {
		const token = await Fetch.getBearerToken();

		headers = {
			'Content-Type': `application/json`,
			...(requiresAuthentication && token && { Authorization: `Bearer ${token}`}),
			...headers
		};

		return fetch(url, {
			method: `POST`,
			headers: headers,
			credentials: `include`,
			body: JSON.stringify(body)
		}).then(Fetch.catchErr);
	}

	static async patch(url, body, headers = {}, requiresAuthentication = true) {
		const token = await Fetch.getBearerToken();

		headers = {
			'Content-Type': `application/json`,
			...(requiresAuthentication && token && { Authorization: `Bearer ${token}`}),
			...headers
		};

		return fetch(url, {
			method: `PATCH`,
			headers: headers,
			credentials: `include`,
			body: JSON.stringify(body)
		}).then(Fetch.catchErr);
	}

	static async delete(url, headers = {}, requiresAuthentication = true) {
		const token = await Fetch.getBearerToken();

		headers = {
			'Content-Type': `application/json`,
			...(requiresAuthentication && token && { Authorization: `Bearer ${token}`}),
			...headers
		};

		return fetch(url, {
			method: `DELETE`,
			headers: headers,
			credentials: `include`
		}).then(Fetch.catchErr);
	}

	static catchErr(res) {
		if (res.ok) {
			if (res.status !== CONSTANTS.STATUS_CODE.CREATED &&
				res.status !== CONSTANTS.STATUS_CODE.NO_CONTENT) {
				return Fetch.parseResponseAndReturn(res);
			}
			return res;
		} else {
			throw res;
		}
	}

	static parseResponseAndReturn(response) {
		if (response.status === CONSTANTS.STATUS_CODE.NOT_FOUND) {
			return {
				status: response.status,
				title: `Error`,
				message: `Unable to find route to the server...`
			};
		} else {
			const contentType = response.headers.get(`content-type`);
			if (contentType && contentType.indexOf(`application/json`) !== -1) {
				return response.json();
			} else {
				return response;
			}
		}
	}

	static async getBearerToken() {
		if (!userManager) {
			return null;
		}

		const user = await userManager.getUser();

		return _.get(user, `id_token`, null);
	}
}

export default Fetch;
